import { connect } from 'react-redux';
import EventInformation from '../../../components/event/event-details/event-information';
import {
    createEventThunk,
    fetchEventThunk,
    updateFundedDistrict,
    updateFundedRS,
    updateFundedRSS,
    freeEvent,
    eventCost,
    category,
    rejectEventThunk,
    approveEventThunk,
    requestInfoEventThunk,
    updateEventThunk,
    createAndSubmitEventThunk,
    updateAndSubmitEventThunk,
    resetEvent,
    setInvalidTabs,
    toggleEventRejectModal,
    toggleEventRequestModal,
    setEventUserAction,
    setEventErrorMessage,
    fetchEventApprovers,
    setApproverVal,
    handleEventFiles,
    concatEventUploads,
    calcPRAccessible,
    setContract,
    fetchParentSearch,
    setParentSearch,
    handleSetParentEvent,
    setPRModal,
    setPRComplete,
    setMCRCUploadedFile,
    setRegionalUploadedFile,
    setDistrictUploadedFile,
    setEventRecommended,
    updateAndApproveEventThunk,
    setEventDates,
    checkMaster,
    formSaved,
    setFormPristine,
    toggleEventApproveModal,
    assignmentOptionsThunk,
    assigneeOptionsThunk,
    showHideAssignedLocation,
    removeAssignee,
    removeDocumentFiles,
    associateUploadedFile,
    setOSSRSSType,
    recallEventThunk,
    resetTime
} from '../../../actions';

import {
    getFundedRegionCodeList,
    getFundedDistrictCodeList,
    getFundedRecruitingStationCodeList,
    getFundedRecruitingSubStationCodeList,
    getCategoryList,
    getFiscalYearList,
    getEventActions,
    getEventForm,
    getEventStatus,
    getAssignmentOptions,
    getAssigneeOptions,
    getShowHideAssignedLocation,
    getAssigneeLoading,
    getAssigneeUsername,
    getAssigneeId
} from '../../../reducers';

const mapStateToProps = state => ({
    isLinkedToParentEvent: state.forms.event.isFromEac,
    categories: state.event.category,
    fundedRegionCodeList: getFundedRegionCodeList(state),
    fundedDistrictCodeList: getFundedDistrictCodeList(state),
    fundedRecruitingStationCodeList: getFundedRecruitingStationCodeList(state),
    fundedRecruitingSubStationCodeList: getFundedRecruitingSubStationCodeList(
        state
    ),
    ossCode: state.event.fundingRecruitingSubStationCode,
    categoryList: getCategoryList(state),
    fiscalYearList: getFiscalYearList(state),
    eventActions: getEventActions(state),
    eventForm: getEventForm(state),
    status: getEventStatus(state),
    userInfo: state.data.userInfo,
    hasActions: state.events.hasActions,
    hasAfterActionActions: state.events.hasAfterActionActions,
    showParentIdField: state.forms.event.showParentIdField,
    rejectModalActive: state.events.rejectModalActive,
    requestModalActive: state.events.requestModalActive,
    approveModalActive: state.events.approveModalActive,
    userAction: state.events.userAction,
    cost: state.forms.event.cost,
    greaterThanRanks: state.data.greaterThanRanks,
    approvers: state.events.approvers,
    tasks: state.events.tasks,
    eventId: state.events.id,
    userIsCreator: state.events.userIsCreator,
    eventSaveSubmit: state.events.eventSaveSubmit,
    eventApproveReject: state.events.eventApproveReject,
    jwtToken: state.auth.jwtToken,
    uploadedFiles: state.events.eventFiles,
    prComplete: state.events.prComplete,
    parentSearchResults: state.events.parentSearchResults,
    prModalActive: state.events.prModal,
    mcrcUploadedFile: state.events.mcrcUploadedFile,
    districtUploadedFile: state.events.districtUploadedFile,
    regionalUploadedFile: state.events.regionalUploadedFile,
    onsiteActivations: state.events.onsiteActivations,
    eventRecommended: state.events.eventRecommended,
    recommend: state.forms.event.recommend,
    recommendReason: state.forms.event.recommendReason,
    selectedCategories: state.events.selectedCategories,
    showEventRecommend: state.events.showEventRecommend,
    startDate: state.event.sDate,
    endDate: state.event.eDate,
    formTouched: state.forms.event.$form.touched,
    purchaseRequest: state.PurchaseRequest,
    approverSet: state.events.approverSet,
    getAssignmentOptions: getAssignmentOptions(state),
    getAssigneeOptions: getAssigneeOptions(state),
    getAssigneeLoading: getAssigneeLoading(state),
    getShowHideAssignedLocation: getShowHideAssignedLocation(state),
    getAssigneeId: getAssigneeId(state),
    getAssigneeUsername: getAssigneeUsername(state),
    assignAfterActionForm: state.forms.event.assignmentOption,
    ossRssType: state.event.ossRssType
});

const mapDispatchToProps = dispatch => ({
    removeAssignee: () => dispatch(removeAssignee()),
    showHideAssignedLocation: () => dispatch(showHideAssignedLocation()),
    assignmentOptionsThunk: () => dispatch(assignmentOptionsThunk()),
    assigneeOptionsThunk: e => dispatch(assigneeOptionsThunk(e)),
    createEvent: (body, vendors) => dispatch(createEventThunk(body, vendors)),
    fetchEvent: e => dispatch(fetchEventThunk(e)),
    updateFundedDistrict: e => dispatch(updateFundedDistrict(e)),
    updateFundedRS: e => dispatch(updateFundedRS(e)),
    updateFundedRSS: e => dispatch(updateFundedRSS(e)),
    freeEvent: e => dispatch(freeEvent(e)),
    eventCost: e => dispatch(eventCost(e)),
    category: e => dispatch(category()),
    rejectEvent: body => dispatch(rejectEventThunk(body)),
    approveEvent: body => dispatch(approveEventThunk(body)),
    requestInfoEvent: body => dispatch(requestInfoEventThunk(body)),
    updateEvent: (body, vendors) => dispatch(updateEventThunk(body, vendors)),
    resetEvent: () => dispatch(resetEvent()),
    createAndSubmitEvent: (body, vendors) =>
        dispatch(createAndSubmitEventThunk(body, vendors)),
    updateAndSubmitEvent: (body, vendors) =>
        dispatch(updateAndSubmitEventThunk(body, vendors)),
    setInvalidTabs: e => dispatch(setInvalidTabs(e)),
    toggleRejectModal: () => dispatch(toggleEventRejectModal()),
    toggleRequestModal: () => dispatch(toggleEventRequestModal()),
    toggleApproveModal: () => dispatch(toggleEventApproveModal()),
    setEventUserAction: action => dispatch(setEventUserAction(action)),
    setEventErrorMessage: text => dispatch(setEventErrorMessage(text)),
    fetchEventApprovers: amount => dispatch(fetchEventApprovers(amount)),
    setApproverVal: val => dispatch(setApproverVal(val)),
    handleFiles: files => dispatch(handleEventFiles(files)),
    concatEventUploads: files => dispatch(concatEventUploads(files)),
    calcPRAccessible: () => dispatch(calcPRAccessible()),
    setContract: e => dispatch(setContract(e)),
    fetchParentSearch: name => dispatch(fetchParentSearch(name)),
    setParentSearch: arr => dispatch(setParentSearch(arr)),
    handleSetParentEvent: (item, name) =>
        dispatch(handleSetParentEvent(item, name)),
    hidePRModal: () => dispatch(setPRModal(false)),
    showPRModal: () => dispatch(setPRModal(true)),
    checkMaster: e => dispatch(checkMaster(e)),
    setPRComplete: bool => dispatch(setPRComplete(bool)),
    setMCRCUploadedFile: bool => dispatch(setMCRCUploadedFile(bool)),
    setRegionalUploadedFile: bool => dispatch(setRegionalUploadedFile(bool)),
    setDistrictUploadedFile: bool => dispatch(setDistrictUploadedFile(bool)),
    setEventRecommended: bool => dispatch(setEventRecommended(bool)),
    updateAndApproveEvent: data => dispatch(updateAndApproveEventThunk(data)),
    setEventDates: (startDate, endDate) =>
        dispatch(setEventDates(startDate, endDate)),
    updateFormSave: bool => dispatch(formSaved(bool)),
    setFormPristine: () => dispatch(setFormPristine()),
    removeDocumentFiles: (index, data) =>
        dispatch(removeDocumentFiles(index, data)),
    associateUploadedFile: data => dispatch(associateUploadedFile(data, true)),
    setOSSRSSType: event => dispatch(setOSSRSSType(event)),
    recallEventThunk: () => dispatch(recallEventThunk()),
    resetTime: dateType => dispatch(resetTime(dateType))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EventInformation);



// WEBPACK FOOTER //
// ./src/containers/event/event-details/event-information.js